
states = ($stateProvider) ->
    'ngInject'

    $stateProvider.state 'tag',
        url: '/tags'
        parent: 'basic'
        abstract: true
        templateUrl: 'empty'

    $stateProvider.state 'tag.index',
        url: ''
        template: "<tag-index></tag-index>",

    $stateProvider.state 'program.tag',
        url: '/tags'
        abstract: true
        templateUrl: 'tags/base'

    $stateProvider.state 'program.tag.index',
        url: ''
        template: "<tag-index tag-for='participant' program='program'></tag-index>",

module.config(states)
